import { useCallback, useState } from "react";
import useAppDispatch from "@/core/helpers/useAppDispatch.ts";
import useAppSelector from "@/core/helpers/useAppSelector";
import { setPinConfirmed, socialClubSelector } from "@/domains/auth/slice";
import toast from "@/domains/toasts/helpers/toast.ts";
import useSignInPin from "@/domains/auth/hooks/useSignInPin.ts";
import AuthUpdatePin from "@/domains/auth/components/update/AuthUpdatePin.tsx";

export default function AuthCreatePinContainer() {
  const dispatch = useAppDispatch();
  const [pin, setPin] = useState<string>("");
  const [pinRepeat, setPinRepeat] = useState<string>("");
  const { pending, error, setError, onSubmit } = useSignInPin();
  const socialClub = useAppSelector(socialClubSelector);

  const onChangePin = useCallback((value: string) => {
    setPin(value);
    setError("");
  }, []);

  const onNonMatchedHandler = useCallback(() => {
    setError("Пин-коды не совпадают");
    setPinRepeat("");
  }, [setError]);

  const onSubmitHandler = useCallback(async () => {
    await onSubmit(pin);
    dispatch(setPinConfirmed(true));
    toast.success(`Успешная регистрация <strong>${socialClub}<strong>`);
  }, [onSubmit, pin, dispatch]);

  return (
    <AuthUpdatePin
      title="Установка пин-кода"
      pin={pin}
      onPinChange={onChangePin}
      pinRepeat={pinRepeat}
      onNotMatched={onNonMatchedHandler}
      onPinRepeatChange={setPinRepeat}
      onSubmit={onSubmitHandler}
      pending={pending}
      error={error}
    />
  );
}
